<template>
  <div class="selected-scene-panel">
    <img :src="imageUrl" alt="sceneName" class="selected-scene-panel__image" />
    <div class="selected-scene-panel__body">
      <p class="selected-scene-panel__body__name">
        {{ sceneName }}
      </p>
      <p class="selected-scene-panel__body__description">
        {{ sceneDescription }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    sceneName: {
      type: String,
      required: true
    },
    sceneDescription: {
      type: String,
      required: true
    }
  }
}
</script>
